import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';
import AvailableErrorList from 'containers/AvailableErrorList';
import AvailableProjectTradeList from 'containers/AvailableProjectTradeList';
import InfoIcon from 'icons/info.svg';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import SequenceOfOperationsFooter from 'components/projectForm/SequenceOfOperationsFooter';

import { toggleGrabbing } from 'components/helpers/document';

export default function SequenceOfOperationsPage({
  addError,
  anySorting,
  anyUnsaved,
  containerStyling,
  dispatch,
  isAvailable,
  isFetching,
  isReviewing,
  projectId,
}) {
  const containerRef = useRef();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'pages.SequenceOfOperationsPage',
  });

  const { t: i18nTCommon } = useTranslation('common');

  useEffect(() => {
    requestProjectTrades();
  }, []);

  useEffect(() => {
    toggleGrabbing(anySorting);
  }, [anySorting]);

  const requestProjectTrades = () => {
    axios
      .get(`/projects/${projectId}/project_trades`)
      .then((response) =>
        dispatch({
          type: 'LOAD_COLLECTION',
          payload: response.data,
          resourceType: 'projectTrade',
        }),
      )
      .catch(() =>
        addError(uuidv4(), {
          fullMessage: i18nTCommon('shared.errors.generic'),
        }),
      );
  };

  return (
    <div
      className={classNames('tw-pt-7.5', anySorting && 'no-user-select')}
      data-element-name='sequence-of-operations-page'
    >
      <div ref={containerRef} style={containerStyling}>
        <h2 className='tw-mt-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
          {i18nTCommon('projects.sequenceOfOperations')}
        </h2>
        <div className='tw-m-0 tw-mb-6 tw-flex tw-rounded-lg tw-border-0 tw-bg-cyan-025 tw-p-3 tw-text-cyan-800'>
          <div className='tw-mr-3 tw-h-5'>
            <InfoIcon
              className='[&_path]:tw-fill-cyan-800'
              height={20}
              width={20}
            />
          </div>
          <p className='tw-m-0'>{i18nT('description')}</p>
        </div>
        {!isFetching &&
          (isAvailable ?
            <div>
              <h3 className='tw-text-l tw-font-semibold tw-text-grey-900'>
                {i18nT('noSequenceAvailable.title')}
              </h3>
              <p>{i18nT('noSequenceAvailable.description')}</p>
            </div>
          : <AvailableProjectTradeList containerRef={containerRef} />)}
        <div id='modalRoot' />
        <AvailableErrorList />
        <SequenceOfOperationsFooter
          anyUnsaved={anyUnsaved}
          isReviewing={isReviewing}
          projectId={projectId}
        />
      </div>
    </div>
  );
}
